import {FORM} from '../../../../../../js/constants/form-types';
import Button from '../../../../../ui/button/Button';

const restaurantEdit = {
    titleForm: "Modifier un restaurant",
    subTitleForm: 'Veuillez compléter les champs ci-dessous pour configurer un nouveau restaurant',
    langSelect: false,
    drawerType: 'drawer',
    noForm: true,
    component: Button,
    textButtonValidate: 'Modifier le restaurant',
    formConfig: {
        type: FORM,
        finalStep:{},
        children:[
            {
                labelName: 'Identité',
                optionsInputs:[]
            },
        ]
    }
}

export default restaurantEdit;
